"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>VoiceControlButton_VoiceControlButton
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const external_pcln_popover_namespaceObject = require("pcln-popover");
var external_pcln_popover_default = /*#__PURE__*/ __webpack_require__.n(external_pcln_popover_namespaceObject);
const ChatbotDataContext_js_namespaceObject = require("../../../context/ChatbotDataContext.js");
const RealtimeIcon_js_namespaceObject = require("../../../svgs/RealtimeIcon.js");
var RealtimeIcon_js_default = /*#__PURE__*/ __webpack_require__.n(RealtimeIcon_js_namespaceObject);
const RealtimeToolTipInfo_js_namespaceObject = require("../../../Voice/RealtimeToolTipInfo.js");
var RealtimeToolTipInfo_js_default = /*#__PURE__*/ __webpack_require__.n(RealtimeToolTipInfo_js_namespaceObject);
const MicIcon_js_namespaceObject = require("../../../svgs/MicIcon.js");
var MicIcon_js_default = /*#__PURE__*/ __webpack_require__.n(MicIcon_js_namespaceObject);
const useRealTimeContext_js_namespaceObject = require("../../../hooks/useRealTimeContext.js");
const external_RealtimeInfoModal_js_namespaceObject = require("./RealtimeInfoModal.js");
var external_RealtimeInfoModal_js_default = /*#__PURE__*/ __webpack_require__.n(external_RealtimeInfoModal_js_namespaceObject);
const MicContainer = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Box).withConfig({
    displayName: "VoiceControlButton__MicContainer"
})([
    "height:49px;width:49px;z-index:1000;"
]);
const PopoverContent = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Flex).withConfig({
    displayName: "VoiceControlButton__PopoverContent"
})([
    "z-index:1000;"
]);
const VoiceControlButton = ({ isExpandableTextArea })=>{
    const { enableVoiceTooltip } = (0, external_react_namespaceObject.useContext)(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    const { setStartRealTime, isRealtime } = (0, useRealTimeContext_js_namespaceObject.useRealTimeContext)();
    const [isMounted, setIsMounted] = (0, external_react_namespaceObject.useState)(false);
    const [showRealTimeInfoModal, setShowRealTimeInfoModal] = (0, external_react_namespaceObject.useState)(false);
    const [showVoiceTooltip, setShowVoiceTooltip] = (0, external_react_namespaceObject.useState)(true);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if ('undefined' != typeof localStorage && localStorage.getItem) {
            const userClosedTooltip = localStorage.getItem('userClosedVoiceModeTooltip');
            'true' !== userClosedTooltip ? setShowVoiceTooltip(true) : setShowVoiceTooltip(false);
        }
    }, []);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (showRealTimeInfoModal) {
            const body = document.querySelector("body");
            body.style.setProperty('position', 'static', 'important');
        }
    }, [
        showRealTimeInfoModal
    ]);
    (0, external_react_namespaceObject.useEffect)(()=>{
        setIsMounted(true);
    }, []);
    function handleStartRealTime() {
        setStartRealTime(true);
    }
    function handleShowRealTimeInfoModal(value) {
        setShowRealTimeInfoModal(value);
    }
    function closeTooltip() {
        setShowVoiceTooltip(false);
        if ('undefined' != typeof localStorage && localStorage.setItem) localStorage.setItem('userClosedVoiceModeTooltip', 'true');
    }
    if (!isMounted) return null;
    if (isExpandableTextArea) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_popover_default(), {
                renderContent: ({ handleClose })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(PopoverContent, {
                        id: "voice-mode-tooltip",
                        p: 2,
                        style: {
                            pointerEvents: 'auto'
                        },
                        "data-testid": "voice-tooltip",
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                                height: "40px",
                                width: "40px",
                                m: 2,
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(RealtimeIcon_js_default(), {})
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(RealtimeToolTipInfo_js_default(), {
                                isRealtime: isRealtime,
                                handleShowRealTimeInfoModal: handleShowRealTimeInfoModal
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.CloseButton, {
                                    "data-testid": "tooltip-close-button",
                                    onClick: handleClose
                                })
                            })
                        ]
                    }),
                idx: "voiceModeTooltip",
                zIndex: 1000,
                placement: "top",
                ariaLabel: "Voice Mode Information",
                width: 310,
                stopPropagation: false,
                toggleIsOpenOnClick: false,
                openOnHover: false,
                openOnFocus: false,
                openOnMount: false,
                onClose: closeTooltip,
                isOpen: showVoiceTooltip && enableVoiceTooltip && !showRealTimeInfoModal,
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.IconButton, {
                    onClick: handleStartRealTime,
                    "data-testid": "real-time-record-button",
                    icon: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(RealtimeIcon_js_default(), {
                        size: 'sm'
                    })
                })
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_RealtimeInfoModal_js_default(), {
                setShowRealTimeInfoModal: setShowRealTimeInfoModal,
                setShowVoiceTooltip: setShowVoiceTooltip,
                showRealTimeInfoModal: showRealTimeInfoModal
            })
        ]
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_popover_default(), {
                renderContent: ({ handleClose })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(PopoverContent, {
                        id: "voice-mode-tooltip",
                        p: 2,
                        style: {
                            pointerEvents: 'auto'
                        },
                        "data-testid": "voice-tooltip",
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                                height: "40px",
                                width: "40px",
                                m: 2,
                                children: isRealtime ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(RealtimeIcon_js_default(), {}) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(MicIcon_js_default(), {
                                    width: '30'
                                })
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(RealtimeToolTipInfo_js_default(), {
                                isRealtime: isRealtime,
                                handleShowRealTimeInfoModal: handleShowRealTimeInfoModal
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.CloseButton, {
                                    "data-testid": "tooltip-close-button",
                                    onClick: handleClose
                                })
                            })
                        ]
                    }),
                idx: "voiceModeTooltip",
                zIndex: 1000,
                placement: "top",
                ariaLabel: "Voice Mode Information",
                width: isRealtime ? 310 : 290,
                stopPropagation: false,
                toggleIsOpenOnClick: false,
                openOnHover: false,
                openOnFocus: false,
                openOnMount: false,
                onClose: closeTooltip,
                isOpen: showVoiceTooltip && enableVoiceTooltip && !showRealTimeInfoModal,
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(MicContainer, {
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.IconButton, {
                        onClick: handleStartRealTime,
                        "data-testid": "real-time-record-button",
                        icon: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(RealtimeIcon_js_default(), {
                            size: 'md'
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_RealtimeInfoModal_js_default(), {
                setShowRealTimeInfoModal: setShowRealTimeInfoModal,
                setShowVoiceTooltip: setShowVoiceTooltip,
                showRealTimeInfoModal: showRealTimeInfoModal
            })
        ]
    });
};
const VoiceControlButton_VoiceControlButton = VoiceControlButton;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
